/// <amd-module name="Artifacts/Package/components/package-details-common/PackagePeople" />
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import * as PackageRes from "Artifacts/Package/Resources";
import * as React from "react";
import { Icon } from "VSSUI/Icon";

export interface IPackagePeopleProps {
  authors: string[];
}

export class PackagePeople extends React.PureComponent<IPackagePeopleProps> {
  public render(): JSX.Element {
    return (
      <div className="package-people">
        <PackageAttribute title={PackageRes.PackagePeople_Title}>
          <div className="package-group-header" role="heading" aria-level={3}>
            {PackageRes.PackagePeople_Authors}
          </div>
          {this.props.authors.map((author) => {
            return (
              <div className="package-attribute-item" key={author}>
                <Icon className={"package-attribute-item-icon"} iconName="Contact" />
                {author}
              </div>
            );
          })}
        </PackageAttribute>
      </div>
    );
  }
}
